export default import.meta.ROLLDOWN_FILE_URL_Z1DkR2M0KlS20JjInS_S8Q